export const LoginMethods = {
  TOKEN: 'token',
  LINK: 'link',
  SSO: 'sso',
};
